export async function deleteFolder(folderId) {
    const response = await fetch(`https://html-creator.demo.cartago.com/api/folders/delete-folder/${folderId}`, {method:'DELETE'});
    const result = await response.json();
    console.log(result.message);
  }
  